import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickStandardLotState = createSelector(
  getOneClickState,
  state => state.stdLotState,
);

export const getOneClickStandardLot = createSelector(
  getOneClickStandardLotState,
  state => state.standardLotAvailable,
);

export const getOneClickTransportationList = createSelector(
  getOneClickStandardLotState,
  state => state.standardLotAvailable.transportation.transportationList,
);

export const getOneClickStandardLotSelected = createSelector(
  getOneClickStandardLotState,
  state => state.selected,
);
